module.exports = __webpack_public_path__ + "static/media/logotipo.4d2d3a58.png";